<template>
  <BriefStep :title="title">
    <template v-slot:content>
      <div class="brief-form">
        <div
          class="
            form__input-wrapper
            form__input-wrapper--check
            form__input-wrapper--check-squer
          "
          v-for="checkbox in formCheckboxes"
          :key="checkbox.name"
        >
          <input
            class=""
            :id="checkbox.name"
            type="checkbox"
            :name="checkbox.name"
            :value="checkbox.value"
            v-model.trim="form.siteJob"
            @input="invokeTouch($v.form.siteJob)"
          />
          <label :for="checkbox.name" class="form__label">{{
            checkbox.label
          }}</label>
        </div>
        <div
          class="
            form__input-wrapper
            form__input-wrapper--check
            form__input-wrapper--check-squer
          "
        >
          <input
            class=""
            id="sj-other"
            type="checkbox"
            name="sj-other"
            value="Inne"
            @input="invokeTouch($v.form.siteJob)"
            @click="otherHandler"
          />
          <label for="sj-other" class="form__label">Inne</label>
        </div>
        <transition name="fade-input">
          <div
            v-if="hasDescription"
            class="form__input-wrapper"
            :class="{ error: $v.form.siteJobOther.$anyError }"
          >
            <label for="siteOtherMaterials" class="form__label uk-hidden"
              >Podaj inne</label
            >
            <input
              class="form-input uk-width-1-1"
              id="siteJobOther"
              type="text"
              name="siteJobOther"
              ref="otherInput"
              @input="event => delayTouchCounterComposition($v.form, 'siteJobOther', event.target.value)"
            />
            <span class="form__error-message form__error-message--no-label">
              <template v-if="!$v.form.siteJobOther.minLength">
                {{ validationMessage.minLength }}</template
              >
              <template v-if="!$v.form.siteJobOther.required">
                {{ validationMessage.required }}</template
              >
            </span>
          </div>
        </transition>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';

import BriefStep from '../global/BriefStep.vue';

export default {
  name: 'SiteJob',
  components: { BriefStep },
  mixins: [stepValidation],
  data: () => ({
    title:
      'Najważniejsze to wyznaczać sobie ambitne cele. Jakie zadanie ma spełniać Twoja strona?',
    form: {
      siteJob: [],
      siteJobOther: '',
    },
    hasDescription: false,
    formCheckboxes: [
      {
        name: 'sj-build',
        value: 'budowanie świadomości firmy/produktów/usług',
        label: 'budowanie świadomości firmy/produktów/usług',
      },
      {
        name: 'sj-sell',
        value: 'sprzedaż produktów/usług',
        label: 'sprzedaż produktów/usług',
      },
      {
        name: 'sj-generate',
        value: 'generowanie kontaktów marketingowych',
        label: 'generowanie kontaktów marketingowych',
      },
      {
        name: 'sj-education',
        value: 'edukacja ',
        label: 'edukacja ',
      },
    ],
  }),
  validations() {
    if (!this.hasDescription) {
      return {
        form: {
          siteJob: {
            required,
          },
        },
      };
    }
    return {
      form: {
        siteJob: {},
        siteJobOther: {
          required,
          minLength: minLength(3),
        },
      },
    };
  },
  methods: {
    otherHandler() {
      this.hasDescription = !this.hasDescription;

      if (!this.hasDescription) {
        this.form.siteJobOther = '';
      } else {
        setTimeout(() => {
          this.$refs.otherInput.focus();
        }, 100);
      }
    },
  },
};
</script>
<style scoped>
</style>
